import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, adminOnly = false, partnerOnly = false }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <Loader2 className="h-6 w-6 animate-spin text-white" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Partner-only portal stays partner-exclusive.
  if (partnerOnly && user.role !== "partner") return <Navigate to="/app" replace />;
  // Admin area is staff-only; partners/clients are redirected to their home.
  if (adminOnly && !["admin", "manager", "mentor"].includes(user.role))
    return <Navigate to={user.role === "partner" ? "/partner" : "/app"} replace />;
  return children;
}
